import React from "react";

import { Input, Measurement, MeasurementNew, Textarea } from "../../../../form-inputs/inputs";
import classnames from "classnames";

const ServingInfo = (props) => {
    const classNames = classnames("serving-info", {
        "horizontal-scroll": props.enableHorizontalScroller,
    });
    const servingInfo = props.data.map((serving, index) => {
        const { servingAccuracy, header, servingSize, servingSizeMetric, servingSizeVisual, servingsPerContainer, servingSizeDescription } = serving;

        return (
            <div
                key={`serving_${index}_${props.panel}`}
                className="column"
            >
                <Input
                    id={`header_${index}`}
                    name="header"
                    label={`Header ${index + 1}`}
                    value={header}
                    updateOnChange={(name, value) => props.updateField(name, value, index)}
                />
                <br />
                <div className="input-group">
                    <Input
                        id={`servingAccuracy_${index}`}
                        name="servingAccuracy"
                        label="Serving Accuracy"
                        value={servingAccuracy}
                        updateOnChange={(name, value) => props.updateField(name, value, index)}
                    />
                    <Measurement
                        id={`servingSiz_${index}`}
                        name="servingSize"
                        label="Serving Size"
                        defaultValue={servingSize}
                        updateOnChange={(name, value) => props.updateField(name, value, index)}
                    />
                    <MeasurementNew
                        id={`servingSizeMetric_${index}`}
                        name="servingSizeMetric"
                        label="Serving Size (Metric)"
                        defaultValue={servingSizeMetric}
                        updateOnChange={(name, value) => props.updateField(name, value, index)}
                    />
                </div>
                <Input
                    id={`servingSizeVisual_${index}`}
                    name="servingSizeVisual"
                    label="Serving Size (Visual)"
                    value={servingSizeVisual}
                    updateOnChange={(name, value) => props.updateField(name, value, index)}
                />
                <br />
                <Input
                    id={`servingsPerContainer_${index}`}
                    name="servingsPerContainer"
                    label="Servings Per Container"
                    value={servingsPerContainer}
                    updateOnChange={(name, value) => props.updateField(name, value, index)}
                />
                <Textarea
                    id={`servingSizeDescription_${index}`}
                    name="servingSizeDescription"
                    label="Serving Size Description"
                    value={servingSizeDescription}
                    updateOnChange={(name, value) => props.updateField(name, value, index)}
                />
            </div>
        );
    });

    return (
        <div className={classNames}>
            <div className="row">{servingInfo}</div>
        </div>
    );
};

export default ServingInfo;
